// extracted by mini-css-extract-plugin
export default {"iframe":"PuzzleGamePannel_iframe__cyJbU"};